import { Injectable, EventEmitter, isDevMode } from '@angular/core';
import { IErrorHandler } from '../dataModels/contracts/IErrorHandler';
import { Configuration } from '../configurations/shared.config';
import { ResourceService } from '../services/resource.service';

@Injectable()
export class ErrorProviderService implements IErrorHandler {

    public errorHandleRequest: EventEmitter<string> = new EventEmitter<string>();
    public notifyHandleRequest: EventEmitter<string> = new EventEmitter<string>();

    private defaultErrorMessgae;
    constructor(private resource: ResourceService) {
        this.defaultErrorMessgae = this.resource.Localize(Configuration.messages.defaultErrorMessage);
        this.resource = void 0;
    }

    DefaultError() {
        if (isDevMode()) {
            var x = new Error("ErrorProviderService error : default.");
           // console.error(x);
        }
        this.errorHandleRequest.emit(this.defaultErrorMessgae);
    }

    public Handle(error: string) {
        if (isDevMode()) {
            var x = new Error(`ErrorProviderService error : ${error}.`);
           // console.error(x);
        }
        this.errorHandleRequest.emit(error);
    }

    public Notify(msg: string) {
        this.notifyHandleRequest.emit(msg);
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/providers/error-provider.service.ts